import React from 'react'
import styles from './date-picker.module.scss'
import DatePicker, { registerLocale } from "react-datepicker";
import da from "date-fns/locale/da";
registerLocale("da", da)


interface IProps {
  label?: string
  onChange: (value) => void
  disabled?: boolean
  minDate?: Date,
  maxDate?: Date
  selected: Date
  startDate?: Date
  modifiers?: string
}

const DatePickerComponent = React.memo(function DatePickerComponent(props: IProps) {
  return (
    <div className={`${styles.inputField} ${props.modifiers ? props.modifiers : ''}`}>
      {props.label && <span className={styles.inputLabel}>{props.label}</span>}
      <DatePicker
        className={styles.datePicker}
        selected={props.selected}
        dateFormat='dd/MM/yyyy'
        onChange={props.onChange}
        minDate={props.minDate}
        maxDate={props.maxDate}
        locale='da'
        startDate={props.startDate}
        selectsEnd
      />
    </div>
  )
})

export default DatePickerComponent